import type { Pead, PriceDaily } from "epsm-api-types/models";
import type { GroupItem, SeriesDataItem } from "../../../types";

export function getSeriesDataForAllPeads(data: Pead[], price: PriceDaily[]) {
	let result: SeriesDataItem[] = [];
	let counter = 0;
	let maxXvalue = 0;
	let ed = null;
	let startDay = data[data.length - 1]?.earning_day.toISOString();

	if (price.length === 0) return { result, maxXvalue };

	for (let i = 0; i < price.length; i++) {
		const el = price[i];

		if (
			new Date(el.date).toISOString().split("T")[0] !== startDay.split("T")[0]
		) {
			counter++;
			i--;

			startDay = incrementDate(startDay);

			continue;
		}

		let date = counter;
		let division = data
			.findLast(
				(d) =>
					new Date(el.date).getTime() < new Date(d.next_earning_day).getTime(),
			)
			?.earning_day.toISOString()
			.split("T")[0];

		const splitDivision = division?.split("-");
		division = splitDivision
			? `${splitDivision[1]}/${splitDivision[0].slice(2)}`
			: division;

		if (ed !== division && ed !== null) {
			maxXvalue = Math.max(maxXvalue, counter);
			counter = 0;
			date = 0;
		}

		ed = division;
		startDay = incrementDate(startDay).split("T")[0];

		if (!division) continue;

		result.push({ date, adj_close: el.adj_close, division });
		counter++;
	}

	interface GroupedData {
		[key: string]: typeof result;
	}

	const groupedData = result.reduce<GroupedData>((acc, item) => {
		if (acc[item.division] === undefined) {
			acc[item.division] = [];
		}

		acc[item.division].push(item);

		return acc;
	}, {});

	result = Object.entries(groupedData).flatMap(([_division, group]) => {
		const startValue: number =
			group.find((item: GroupItem) => item.date === 0)?.adj_close ?? 1;

		const normalizationFactor = 100 / startValue;

		return group.map((item: GroupItem) => ({
			...item,
			normalizedPrice: (item.adj_close ?? 0) * normalizationFactor,
		}));
	});

	return { result, maxXvalue };
}

function incrementDate(date: string) {
	const nextDay = new Date(date);
	nextDay.setDate(nextDay.getDate() + 1);
	return nextDay.toISOString();
}
